/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React from 'react';
import { PriceHandler } from '../../../../redux/helper/CamelCase';

function DirectOrderSummary({
    OrderDetails,
}) {
    return (
        <div className="w-full">
            <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                        <p className="font-normal text-sm text-[#555259]">
                            {OrderDetails?.summary?.quantity && Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                                <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                                    {Number(OrderDetails?.summary?.quantity[UOM])}
                                    {' '}
                                    {UOM}
                                    {' '}
                                    <br />
                                </span>
                            ))}

                        </p>
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]" data-testid="order-type">
                        {OrderDetails?.order_type }
                        {' '}
                        Order
                    </p>
                </div>
                <div className="pt-1.5">
                    <div>
                        <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                        <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.order_value)}
                                    {' '}
                                </p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.total_discount)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary?.sub_total)}</p>
                            </div>
                        </div>
                        <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.order_gst.gst)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2 py-1">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]" data-testid="total-amount">{PriceHandler(OrderDetails?.summary?.order_gross_amount)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DirectOrderSummary;
